module.exports = __webpack_public_path__ + "img/1123533204.b55bc26e.png";